export const X_HOST_HEADER_KEY = 'X-HOST';
